export default __webpack_public_path__ + "static/media/threeTopLeft.d407543c.png";